import { Component, inject } from '@angular/core';
import { KpiWidgetComponent } from '../../../../../../_shared/components/kpi-widget/kpi-widget.component';
import { BaseWidgetComponent } from '../../../../../../home/home-widgets/widgets/base-widget.component';
import { FilterService } from '../../../../../../_shared/services/filter.service';
import { TranslocoService } from '@jsverse/transloco';
import { InsuranceClaimsService } from '../../../services/insurance-claims.service';
import { ErrorHandlerService } from '../../../../../../_shared/services/error-handler.service';
import { SummaryRequest } from '../../../../../../_shared/models/summary-request.model';
import { AuthService } from '../../../../../../_shared/services';
import { CurrencyHelper } from '../../../../../../_shared/helpers/currency/currency-map.helper';
import { formatCost } from '../../../../../../_shared/helpers/kpiWidget/kpi-formatters.helper';

@Component({
  selector: 'app-total-amount-claimed',
  standalone: true,
  imports: [KpiWidgetComponent],
  templateUrl: './total-amount-claimed.component.html',
  styleUrl: './total-amount-claimed.component.scss'
})
export class TotalAmountClaimedComponent extends BaseWidgetComponent {
  private claimsService = inject(InsuranceClaimsService);
  private errorService = inject(ErrorHandlerService);
  private authService = inject(AuthService);

  hasError: boolean = false;
  errorMessage: string = '';
  currencySymbol: string = '';

  constructor() {
    const filterService: FilterService = inject(FilterService);
    super(filterService);
    const transloco: TranslocoService = inject(TranslocoService);
    this.title = transloco.translate('accidents.claims.widgets.totalAmountClaimed');
    this.isLoading = true;
    this.value = 0;
    this.percentageDifference = 0;

    const currencyCode = this.authService.getUserSettings()?.currencyCode ?? 'ZAR';
    this.currencySymbol = CurrencyHelper.getCurrencySymbol(currencyCode);
  }

  protected override async onFilterChangeAsync(): Promise<void> {
    this.isLoading = true;
    this.hasError = false;

    try {
      this.cancelSubject.next();
      const request: SummaryRequest = {
        accountIds: this.widgetFilter.accountIds,
        timeFrom: this.widgetFilter.startDate!,
        timeTo: this.widgetFilter.endDate!,
        interval: this.widgetFilter.interval,
        previousTimeFrom: this.widgetFilter.previousCycleStartDate!,
        previousTimeTo: this.widgetFilter.previousCycleEndDate!
      };
      const response = await this.claimsService.getTotalAmountClaimedKpi(request, this.cancelSubject);
      this.value = response.data?.totalValue ?? 0;
      this.percentageDifference = response.data?.percentageChange ?? 0;

      this.isLoading = false;
    } catch (error: any) {
      this.errorService.handleError(error, {
        callback: (errorMessage) => {
          this.hasError = true;
          this.errorMessage = errorMessage;
          this.isLoading = false;
        }
      });
    }
  }

  public override formatValue(value: number): string {
    const sign = value < 0 ? '-' : '';
    return `${sign}${formatCost(Math.abs(value), this.currencySymbol)}`;
  }
}